module.exports = __webpack_public_path__ + "img/jabamuneco.5ea779fe.jpg";